<template>
   <FilterExpandCollapse label="Network you're viewing" :expand="true" v-if="plans">
        <div>
          <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
          <FilterNetworkMarketingGroupHeader v-if="context.marketingGroup && !profile.isAuthenticated" />
          <div v-else>
            <FilterNetworkPlanName :plans="plans"/>
            <FilterNetworkPlanSelection :plans="plans"/>
          </div>
          <hp5-spacing-vertical xs="xs" sm="xs" md="xs" lg="xs" />
          <FilterNetworkCoverageLink />
          <FilterNetworkPCCUser />          
          <FilterNetworkAsOfDate v-if="!profile.isAuthenticated"/>
          <FilterNetworkPlanSwitcher />
        </div>
     </FilterExpandCollapse>
</template>
  
<script setup>
/**
 * This component manages the UI and state for the Network filter.  The inputs to this component are profile and context state,
 * in particular the search 'type' and 'networkIndex'.  The component manages the networkIndex in the context.  If there is only one
 * plan, there will be no selections just a description of the plan.
 */

    const model = useFCPModel()
    const { profile, filterContext, context } = model  
    const type = computed(() => filterContext.value.type)
    const networkIndex = computed(() => filterContext.value.networkIndex)
  
    const resolvePlans = () => {
      if (profile.value && filterContext.value) {
        const { getPlans } = usePlan(profile.value, filterContext.value)
        return getPlans()
      }
      return []
    }

    const plans = ref(resolvePlans())

    watch(filterContext, (current, old) => {
        plans.value = resolvePlans()
    })
  
  
    //   /* adding watcher here for network index change, this would trigger plan change 
    //   which would allow us to then decide to hide or show benifit level */
      watch(networkIndex, (current, old) => {
        context.value.networkIndex = networkIndex.value
      })
  
    //   //If we have more than one plan, then default to plan at index 0 ( primary plan ) unless the networkIndex has
    //   //been set to something else.
      if (plans.value.length > 1) {
        filterContext.value.networkIndex = filterContext.value.networkIndex ? filterContext.value.networkIndex : 0
      }
  
    //   //Watch for a change in the search type.  If the search type changes, then we need to get a fresh set of plans
    //   //based upon the latest state ( i.e. medical vs dental. Also, if we ).  If there are multiple plans and no network
    //   //index selected, default the networkIndex the first one - index 0.
      watch(type, (current, old) => {
        if (plans.value.length > 1 && filterContext.value.networkIndex == '') {
          filterContext.value.networkIndex = 0
        }
      })
  
       //for analaytics - track network name on initial search when authenticated
      if (profile.value.isAuthenticated) {
        const digitalData = window.digitalData || []
        const event = 'network_name_authenticated'
        digitalData.push({
          eventData: {
            networkName: model.plan.value.name,
          },
          event: event,
        })
      }

  </script>
  
  <style scoped lang="scss">
  p {
    margin: 0;
  }
  
  .pcClinic-info {
    display: flex;
  }
  </style>